import i18n from "i18next"
import Backend from "i18next-xhr-backend"
import LanguageDetector from "i18next-browser-languagedetector"
import { reactI18nextModule } from "react-i18next"
import ttUserLanguageDetector from "./ttUserLanguageDetector"

// Define the custom language detector which hooks into details
// of the currently authenticated user
const ttCultureDetector = new LanguageDetector()
ttCultureDetector.addDetector(ttUserLanguageDetector)

/* The translation namespace is the filename to use within the language folder
  But we need client-specific translations sometimes, so we use a json translations file
  per client, so the path for the English Purple Cubed translations would be
   /locales/en-GB/translations.5.json
*/

i18n
  .use(Backend)
  .use(ttCultureDetector)
  .use(reactI18nextModule)
  .init({
    backend: {
      loadPath: `${process.env.REACT_APP_I18N_BASE_URL}/{{lng}}/{{ns}}.json`,
      crossDomain: true,
    },

    detection: { order: ["ttUserLanguageDetector"] },

    fallbackLng: "en-GB",

    ns: ["translations"],

    // Define a default namespace so we don't need to define it each time we use the translate HOC
    defaultNS: "translations",

    debug: false, // Can be useful during development

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    react: {
      wait: true,
    },

    load: "currentOnly",
  })

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/i18n.js